import ConsentContext from '../contexts/ConsentContext';
import { useContext } from 'react';

const useConsent = () => {
  const ctx = useContext(ConsentContext);
  if (!ctx) throw new Error('useConsent must be used within ConsentProvider');
  return ctx;
};

export default useConsent;
